import React, { useState } from 'react';
import styled from 'styled-components';
import { Collapse, Loading, Switch, Tooltip } from 'tdesign-react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { setCanRefresh } from '@/slices/execRecordSlice';
import { isVoid } from '@/utils/common';
import { RESULT_STATUS, getExecResultCodeStatus } from '../..';
import Variables from './Variables';
import Log from './Log';
import Script from './Script';

const { Panel: CollapsePanel } = Collapse;

function ExecuteInfo({ loading, hostLoading, setCanRefresh, canRefresh, summary, currentHost }) {
  const [expandValue, setExpandValue] = useState([3]);
  return (
    <Root>
      <Title>
        <div>
          执行详情 <Loading style={{ marginLeft: 4 }} loading={loading} size='small' />
        </div>
        {!isVoid(canRefresh) &&
          getExecResultCodeStatus(summary.execResultCode) === RESULT_STATUS.PROCESSING && (
            <Tooltip content='自动刷新开关：3s自动刷新一次' placement='left'>
              <Switch
                label={['开', '关']}
                value={canRefresh}
                onChange={() => setCanRefresh(!canRefresh)}
              />
            </Tooltip>
          )}
      </Title>
      {!hostLoading && !isEmpty(currentHost) && (
        <Collapse
          borderless
          value={expandValue}
          onChange={setExpandValue}
          expandIconPlacement='right'
        >
          <CollapsePanel value={1} header='执行的实际脚本内容'>
            <Script />
          </CollapsePanel>
          <CollapsePanel value={2} header='填写的变量值'>
            <Variables />
          </CollapsePanel>
          <CollapsePanel value={3} header='执行日志'>
            <Log />
          </CollapsePanel>
        </Collapse>
      )}
    </Root>
  );
}

export default connect(
  (state) => ({
    loading: state.execRecord.recordDetailFetching,
    summary: state.execRecord.summary,
    currentHost: state.execRecord.currentHost,
    hostLoading: state.execRecord.recordHostFetching,
    canRefresh: state.execRecord.canRefresh,
  }),
  {
    setCanRefresh,
  },
)(ExecuteInfo);

const Root = styled.div`
  padding: 16px 20px;
  flex: 1;
  min-width: 0;
  .t-collapse-panel__header {
    height: 40px;
    box-sizing: border-box;
    font-weight: normal;
    color: var(--td-text-color-secondary);
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1) !important;
    background: #f7f8fa;
    margin-top: 8px;
  }
  .t-collapse-panel__content {
    padding: 0;
  }
`;

const Title = styled.div`
  color: var(--td-text-color-primary);
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
